import {
  defaultBackgroundImage,
  kawhiaBackgroundImage,
} from "../core/constants/constants";

interface FlavourConfig {
  name: string;
  logo: string;
  backgroundImage: string;
  primaryColor: string;
  primaryColorLight: string;
  secondaryColor: string;
  secondaryColorLight: string;
  inputColor: string;
  inputColorHover: string;
  inputColorLight: string;
  inputColorLightest: string;
}

const hamilton: FlavourConfig = {
  name: "Hamilton City Council",
  logo: "hamilton-logo.png",
  backgroundImage: defaultBackgroundImage,
  primaryColor: "hamilton-primary",
  primaryColorLight: "hamilton-primary-lighter",
  secondaryColor: "hamilton-secondary",
  secondaryColorLight: "hamilton-secondary-lighter",
  inputColor: "gray-600",
  inputColorHover: "gray-500",
  inputColorLight: "gray-200",
  inputColorLightest: "gray-100",
};

const waikato: FlavourConfig = {
  name: "Waikato District Council",
  logo: "waikato-logo.png",
  backgroundImage: defaultBackgroundImage,
  primaryColor: "waikato-primary",
  primaryColorLight: "waikato-primary-lighter",
  secondaryColor: "waikato-secondary",
  secondaryColorLight: "waikato-secondary-lighter",
  inputColor: "gray-600",
  inputColorHover: "gray-500",
  inputColorLight: "gray-200",
  inputColorLightest: "gray-100",
};

const otorohanga: FlavourConfig = {
  name: "Ōtorohanga District Council",
  logo: "otorohanga-logo.png",
  backgroundImage: defaultBackgroundImage,
  primaryColor: "otorohanga-primary",
  primaryColorLight: "otorohanga-primary-lighter",
  secondaryColor: "otorohanga-secondary",
  secondaryColorLight: "otorohanga-secondary-lighter",
  inputColor: "gray-600",
  inputColorHover: "gray-500",
  inputColorLight: "gray-200",
  inputColorLightest: "gray-100",
};

// Created a separate flavour on Otorohanga councils request for customers from Kawhia. Same config but with a different background image.
const kawhia: FlavourConfig = {
  name: "Ōtorohanga District Council",
  logo: "otorohanga-logo.png",
  backgroundImage: kawhiaBackgroundImage,
  primaryColor: "otorohanga-primary",
  primaryColorLight: "otorohanga-primary-lighter",
  secondaryColor: "otorohanga-secondary",
  secondaryColorLight: "otorohanga-secondary-lighter",
  inputColor: "gray-600",
  inputColorHover: "gray-500",
  inputColorLight: "gray-200",
  inputColorLightest: "gray-100",
};

const defaultCouncil: FlavourConfig = {
  name: "a council",
  logo: "",
  backgroundImage: defaultBackgroundImage,
  primaryColor: "indigo-700",
  primaryColorLight: "indigo-600",
  secondaryColor: "hamilton-green",
  secondaryColorLight: "hamilton-green-lighter",
  inputColor: "indigo-700",
  inputColorHover: "indigo-600",
  inputColorLight: "indigo-200",
  inputColorLightest: "indigo-100",
};

const flavours: Record<string, FlavourConfig> = {
  hamilton,
  waikato,
  otorohanga,
  kawhia,
};

const flavour = flavours[process.env.REACT_APP_FLAVOUR ?? ""];
const flavourConfig: FlavourConfig = flavour ?? defaultCouncil;

export default flavourConfig;
